export const MODAL_ID = 'workspaceIntroductionModal';
export const CONTAINER_CLASSNAME = 'workspaceIntroductionModalContainer';
export const NUM_TIMES_TO_SHOW = 2;
